import Vue from 'vue';
import Vuex from 'vuex';
import state from './state.js';
import mutations from './mutations.js';
import actions from './actions.js';
import getters from './getters.js';
import common from './modules/common';
import app from './modules/app';
import user from './modules/user';
Vue.use(Vuex);
export default new Vuex.Store({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
  modules: {
    common: common,
    //多个用,号隔开
    app: app,
    user: user
  }
});